module.exports = __webpack_public_path__ + "static/img/19.44233f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/19.png
// module id = I1VJ
// module chunks = 0